module.exports = __webpack_public_path__ + "img/full-banner.4b6c45b8.png";